import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Hash, ExternalLink } from "lucide-react";

export default function Community() {
  const [channels, setChannels] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => {
    api.get("/community/channels").then(({ data }) => {
      setChannels(data);
      setActive(data[0]);
    });
  }, []);

  return (
    <div data-testid="community-page">
      <div className="overline text-[var(--lh-mauve)] mb-3">Community</div>
      <h1 className="font-serif-display text-5xl tracking-tighter leading-[0.95]">
        Inside <em>the room.</em>
      </h1>
      <p className="mt-4 text-[var(--lh-text)] font-light max-w-2xl">
        Our private community runs on Slack. Channels for wins, marketing help, brand feedback, and your city chapter.
      </p>

      <div className="mt-12 grid lg:grid-cols-12 gap-6">
        <aside className="lg:col-span-3 bg-white border border-[var(--lh-border)] p-6">
          <div className="overline text-[var(--lh-mauve)] mb-4">Channels</div>
          <ul className="space-y-1">
            {channels.map((c) => (
              <li key={c.name}>
                <button
                  onClick={() => setActive(c)}
                  className={`w-full text-left flex items-center gap-2 px-3 py-2 text-sm transition-all ${active?.name === c.name ? "bg-[var(--lh-black)] text-white" : "hover:bg-[var(--lh-surface)]"}`}
                  data-testid={`channel-${c.name}`}
                >
                  <Hash size={14} /> {c.name}
                </button>
              </li>
            ))}
          </ul>
        </aside>

        <section className="lg:col-span-9 bg-white border border-[var(--lh-border)] p-10">
          {active ? (
            <>
              <div className="flex items-center gap-2 mb-6">
                <Hash size={18} className="text-[var(--lh-mauve)]" />
                <span className="font-serif-display text-2xl">{active.name}</span>
                <span className="overline text-[var(--lh-muted)] ml-3">{active.active_today} active today</span>
              </div>
              <p className="text-[var(--lh-text)] font-light italic mb-8">"{active.topic}"</p>
              <div className="p-8 bg-[var(--lh-surface)] text-center rounded-2xl">
                <div className="overline text-[var(--lh-mauve)] mb-3">Slack workspace</div>
                <div className="font-serif-display text-2xl mb-3">Open #{active.name} in Slack</div>
                <p className="text-sm text-[var(--lh-muted)] mb-6 max-w-md mx-auto">
                  Members get a Slack invite via email. Already have access? Jump in below.
                </p>
                <a
                  href="https://slack.com"
                  target="_blank"
                  rel="noreferrer"
                  className="btn-primary"
                  data-testid="community-open-slack"
                >
                  Open Slack <ExternalLink size={14} />
                </a>
              </div>
            </>
          ) : <div className="overline text-[var(--lh-muted)]">Loading channels…</div>}
        </section>
      </div>
    </div>
  );
}
